<template>

  <b-row>
    <b-col>
      <b-card 
        style="margin:0;border:1px solid #2980b9 ;padding:0 10px" 
        no-body
        :class="{ 'open': visibleBody }" 
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>REVISION DE ORGANOS Y SISTEMAS </strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-form-group label="Seleccionar la revisión: ">
              <b-form-checkbox-group
                :options="organosSistemasOpts"
                plain
                size="lg"
                v-model="organosSistemasChecked"
              />
            </b-form-group>

            <div 
              v-for="(item) in organosSistemasItems" 
              :key="item.value" 
              class="row my-2 d-flex align-items-center"
            >
              <div class="col-sm-3">
                <label>{{ item.text }}</label>
              </div>

              <!-- <div class="col-sm-1">
                <b-checkbox switch size="sm" v-model="item.checked"/>
              </div>   -->

              <div class="col-sm-8">

                <v-select
                  v-if="item.checked"
                  placeholder="Seleccione una o mas opciones"
                  :options="sintomasOptions(item.value)"
                  :reduce="option => option"
                  label="text"
                  :multiple="true"
                  taggable
                  @input="newArray => item.selecteds = onAddNewOpt(newArray)"
                />

                
                <b-form-input
                  v-if="!item.checked"
                  v-model="item.inputText"
                  placeholder="Describa la revision organos..."
                  type="text"
                />

              </div>
            </div>

            
            <div>
              <b-form-checkbox
                v-model="observaciones.active"
              >
                <label for="">Observaciones Adicionales:</label>
              </b-form-checkbox>

              <b-form-textarea
                v-if="observaciones.active"
                v-model="observaciones.text"
              />
            </div>

            <div>
              <hr>
              <p v-html="summaryText.html"/>
            </div>
            <b-form-group  class = "mt-1" >
              <b-button 
                @click = "copyAS400()" 
                variant = "info"
              >
                AS400  <i class="fas fa-copy"/>
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  

</template>

<script>

import rutas from "@/assets/utils/rutas.json";
import axios from "axios";
import { mapState  } from 'vuex';
import { addNewOpt, convertToSnakeCase, copyText } from "@/shared/helpers";
import vSelect from "vue-select";
import { anamnesisService } from "@/views/atencionMedica/services";


export default {

  name: "RevisionOrganosSistemas",

  components: {
    vSelect
  },

  data(){
    return{
      tokenAtencion: null,
      visibleBody: false,
      organosSistemasChecked: [],
      organosSistemasOpts: [],
      organosSistemasItems: [],

      observaciones:{
        active: false,
        text: '',
      },

      itemsInicial: [],
      itemsToDelete: [],

      dataState:{
        itemsInicial  : [],
        items        : [],
        itemsToDelete: [],
        observaciones:{
          active: false,
          text: '',
        }
      },

    }
  },

  async created() {
    await this.getOrganosSistemasOpts();

    this.loadDataRegister();
  },

  methods: {

    async loadDataRegister(){

      this.tokenAtencion = this.$route.params.token;
      if(!this.tokenAtencion) return;

      const responseRevision = await anamnesisService.getRevOrganosByAtencion(this.tokenAtencion);
      const { revisiones, observaciones } = responseRevision;
      
      const revisionesCheck = revisiones.map( item => item.revisionorganos.descripcion.toLowerCase());
      this.organosSistemasChecked = [...new Set(revisionesCheck)];

      if(observaciones) {
        this.observaciones.active = true;
        this.observaciones.text = observaciones;
      }

      revisiones.forEach( rev => {
        this.organosSistemasItems.push({
          idRevision: rev.id,
          id        : rev.revisionorganos.id,
          value     : rev.revisionorganos.descripcion.toLowerCase(),
          text      : rev.revisionorganos.descripcion,
          inputText : rev.descripcionGeneral,
          selecteds : [],
          checked   : false
        })
      });

      this.itemsInicial = this.organosSistemasItems.map( item => item.idRevision);
    },

    onVisibleBody(value){
      this.visibleBody = value
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    async getOrganosSistemasOpts() {
      const query = `
        query {
          allRevorg {
            id, descripcion
          }
        }
      `;
      try {
        const response = await axios.post(`${rutas.axios}api`, { query });

        this.organosSistemasOpts = response.data.data.allRevorg.map(item => ({
          id: item.id,
          value: item.descripcion.toLowerCase(),
          text: item.descripcion
        }));

      } catch (error) {
        console.error("Error fetching Organos y Servicios:", error);
      }
    },

    sintomasOptions(value){
      return [{ value:'', text:'' }];
    },

    copyAS400() {
      copyText(this.summaryText.text)
    },
  },


  computed: {

    ...mapState({
      stRevisionOrganos: state => state.atencionCita.anamnesis.revisionOrganos,
    }),

    summaryText() {

      const organosSummary = this.organosSistemasOpts.map( o => {
        const item = this.organosSistemasItems.find( i => i.id === o.id );
        if(!item) return `${o.id}. ${o.text}: NO PATOLOGICO`;

        return `${o.id}. ${o.text}: ${item.checked ? item.selecteds.map( opt => opt.text).join(', ') : item.inputText}`;
      })

      // console.log('organosSummary', organosSummary);
      organosSummary.unshift("Revision de Organos y Sistemas: ");

      if (this.observaciones.active && this.observaciones.text.trim() !== '')
        organosSummary.push(`${this.observaciones.text}`);

      const textFinish = {
        html: organosSummary.join('<br>'),
        text: organosSummary.join('\n')
      }
      return textFinish;
    },

  },


  watch: {

    organosSistemasChecked: {

      deep: true,
      handler() {
        this.organosSistemasItems = this.organosSistemasItems.filter(
          item => this.organosSistemasChecked.includes( item.value )
        );

        this.organosSistemasChecked.forEach(id => {
          if (!this.organosSistemasItems.some(item => item.value === id)) {
            const newItem = this.organosSistemasOpts.find(item => item.value === id);

            this.organosSistemasItems.push({
              id: newItem.id,
              value: newItem.value,
              text: newItem.text,
              inputText: '',
              selecteds: [],
              checked: false
            });
          }
        });

      },
    },


    organosSistemasItems: {

      deep: true,
      handler(newValue) {
        this.dataState.items = newValue;

        this.itemsToDelete = this.itemsInicial.filter( item => !newValue.some(newItem => newItem.idRevision === item ) );
      },
    },

    observaciones: {
      deep: true,
      handler(newValue) {
        if(!newValue.active) this.observaciones.text = '';
        this.dataState.observaciones = newValue
      },
    },

    itemsInicial: {
      deep: true,
      handler(newValue) {
        this.dataState.itemsInicial = newValue
      },
    },

    itemsToDelete: {
      deep: true,
      handler(newValue) {
        this.dataState.itemsToDelete = newValue
      },
    },

    dataState: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setRevisionOrganos", newValue);
      },
    },

  },

  


}
</script>
